import type { Cart, ShippingOption } from '@sshop/domain';

export function deliveryProgress(cart: Cart, threshold: number) {
  const totalCents = Math.max(0, Math.round((cart.totals.subtotal.amount - cart.totals.discount.amount) * 100));
  const thresholdCents = Math.round(threshold * 100);
  return {
    total: totalCents / 100,
    remaining: Math.max(0, thresholdCents - totalCents) / 100,
    percent: Math.min(100, totalCents / thresholdCents * 100),
  };
}

export function deliveryPrice(option: ShippingOption, cart: Cart) {
  const threshold = option.freeShippingThreshold;
  const free = threshold != null && deliveryProgress(cart, threshold).remaining === 0;
  return { ...option.price, amount: free ? 0 : option.price.amount };
}
